"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findUserGroupPricing = exports.activityPrice = void 0;
const lodash_1 = require("lodash");
const individualPriceForQuantity_1 = require("./individualPriceForQuantity");
const constants_1 = require("../constants");
function minusPercent(percentage, of) {
    return of / (1 + percentage / 100);
}
const activityPrice = (pricing, people) => {
    const groups = pricing.map((groupPricing) => {
        const groupQuantity = people[groupPricing.customId] || 0;
        const individualPrice = individualPriceForQuantity_1.individualPriceForQuantity(groupPricing.byQuantity, groupQuantity);
        const individualPriceHT = minusPercent(constants_1.TVA.NORMAL, individualPrice);
        return {
            customId: groupPricing.customId,
            label: groupPricing.label,
            price: individualPrice,
            priceHT: Number(individualPriceHT.toFixed(2)),
            count: groupQuantity,
            sum: groupQuantity * individualPrice,
            sumHT: Number((groupQuantity * individualPriceHT).toFixed(2)),
            tvaPercentage: constants_1.TVA.NORMAL,
        };
    });
    const sum = lodash_1.sumBy(groups, (group) => group.sum);
    const sumHT = lodash_1.sumBy(groups, (group) => group.sumHT);
    return {
        sum: sum,
        sumHT: sumHT,
        sumTVA: Number(Number(sum - sumHT).toFixed(2)),
        count: lodash_1.sumBy(groups, (group) => group.count),
        groups,
    };
};
exports.activityPrice = activityPrice;
function findUserGroupPricing(pricing, userGroupId) {
    return pricing.forUserGroups.find((forGroup) => forGroup.userGroupIds.includes(userGroupId));
}
exports.findUserGroupPricing = findUserGroupPricing;
//# sourceMappingURL=activityPrice.js.map